/* ============
 * EXCISE DUTIES Module Mutations
 * ============
 */

import {
  FETCH_ADDITIONAL_CODE,
} from './../../mutation-types';

export default {
  [FETCH_ADDITIONAL_CODE](state, { exciseAdditionals }) {
    state.all = exciseAdditionals;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/additionalCode/mutations.js